/* eslint-disable import/prefer-default-export */
/* eslint-disable camelcase */
import { SilResultSubsystem } from "server/models"
import { LangType } from "client/store"

import { SilTarget } from "client/utils"
import * as Formulas from ".."


export const iec_61511_2003_architecturalConstraints = (
    redundancy: boolean,
    subsystem: SilResultSubsystem,
    targetSil: SilTarget,
    lang: LangType,
) => {
    if (redundancy) {
        const hft = Formulas.getHFT(subsystem.architecture)
        const device = subsystem.blocks[0].projectDevice
        const {
            sil,
            failureRate,
            logicSolver,
            sd,
            su,
            dd,
            du,
        } = device

        const sff = failureRate
            ? Formulas.sff({ su, sd, du, dd })
            : Formulas.parseProp(device.sff)

        if (sil) return lang[`sil_${sil}`]

        if (logicSolver) {
            if (sff >= 0.9) {
                if (targetSil === 3) {
                    if (hft >= 1) return lang.sil_3
                    return lang.notCompliant
                }
                if (targetSil === 1 && hft >= 0) return lang.sil_1
                if (targetSil === 2 && hft >= 0) return lang.sil_2
                return lang.notCompliant
            }
            if (sff >= 0.6 && sff < 0.9) {
                if (targetSil === 3) {
                    if (hft >= 2) return lang.sil_3
                    return lang.notCompliant
                }
                if (targetSil === 2) {
                    if (hft >= 1) return lang.sil_2
                    return lang.notCompliant
                }
                if (targetSil === 1 && hft >= 0) return lang.sil_1
                return lang.notCompliant
            }
            if (sff < 0.6) {
                if (targetSil === 3) {
                    if (hft >= 3) return lang.sil_3
                    return lang.notCompliant
                }
                if (targetSil === 2) {
                    if (hft >= 2) return lang.sil_2
                    return lang.notCompliant
                }
                if (targetSil === 1 && hft >= 1) return lang.sil_1
                return lang.notCompliant
            }
            return lang.notCompliant
        }

        if (!logicSolver) {
            if (targetSil === 4) return lang.notCompliant
            if (targetSil === 3) {
                if (hft >= 2) return lang.sil_3
                return lang.notCompliant
            }
            if (targetSil === 2) {
                if (hft >= 1) return lang.sil_2
                return lang.notCompliant
            }
            if (targetSil === 1 && hft >= 0) return lang.sil_1
            return lang.notCompliant
        }
        return lang.notCompliant
    }
    return lang.notCompliant
}
